import * as React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'

interface Props {
  change: number
}

const DataIndicator = ({ change }: Props) => {
  const getIcon = () => {
    if (change === 0) return 'equals'
    return change > 0 ? 'arrow-top-right' : 'arrow-bottom-right'
  }

  return <Icon.Small color="grey800" icon={getIcon()} />
}

export default DataIndicator
